import { isEmpty } from 'lodash'
import { and, bulletSection, or } from '../helper'

export default [
  {
    generate({ answers, patientData }) {
      const textPieces = []

      if (and(patientData.age >= 6, answers['12'] === 'alta', or(!isEmpty(answers['10']), !isEmpty(answers['13'])))) {
        textPieces.push('corticoide inalatório em alta dose, com beta-2 agonista de longa duração (LABA)')
      } else if (
        and(
          patientData.age >= 6,
          patientData.age <= 11,
          answers['12'] === 'media',
          or(!isEmpty(answers['10']), !isEmpty(answers['13'])),
        )
      ) {
        textPieces.push('corticoide inalatório em média dose, com beta-2 agonista de longa duração (LABA)')
      }

      if (answers['17'] === 'sim') {
        textPieces.push('corticoide oral contínuo nos últimos 6 meses')
      }

      const sections = []

      if (textPieces.length) {
        sections.push(bulletSection('Fez uso de:', textPieces))
      }

      return sections
    },
    version: {
      /** @type {number[]} */
      include: [],
      /** @type {number[]} */
      exclude: [],
    },
  },
]
